(() => {
    function getNewsletterFormType() {
        const params = new URLSearchParams(window.location.search);
        return params.get('newsletter_form');
    }

    function cleanNewsletterUrl() {
        if (!window.history || !window.history.replaceState) return;

        const cleanUrl = window.location.origin + window.location.pathname;
        window.history.replaceState({}, document.title, cleanUrl);
    }

    function closeSuccessPopup(successPopup) {
        successPopup.classList.remove('is-show');

        document.body.classList.remove('newsletter-success-active');
        document.body.classList.remove('popup-lock');
        document.body.style.overflow = '';

        window.dispatchEvent(new CustomEvent('newsletter:success:close'));

        cleanNewsletterUrl();
    }

    function initNewsletterSuccess() {
        const newsletterFormType = getNewsletterFormType();

        document.querySelectorAll('[data-newsletter-success-message]').forEach((message) => {
            if (newsletterFormType && message.dataset.newsletterSuccessMessage !== newsletterFormType) {
                message.remove();
            }
        });

        const successPopup = document.querySelector('[data-newsletter-success-popup]');

        if (!successPopup) return;

        if (newsletterFormType !== 'popup') {
            successPopup.remove();
            return;
        }
        successPopup.classList.add('is-show');
        document.body.classList.add('newsletter-success-active');
        document.body.classList.add('popup-lock');
        document.body.style.overflow = 'hidden';

        window.dispatchEvent(new CustomEvent('newsletter:success:open'));

        document.addEventListener('click', (event) => {
            if (event.target.closest('[data-newsletter-success-close]')) {
                closeSuccessPopup(successPopup);
            }
        });

        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && successPopup.classList.contains('is-show')) {
                closeSuccessPopup(successPopup);
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initNewsletterSuccess);
    } else {
        initNewsletterSuccess();
    }
})();